<template>
  <div class="file-pick">
    <vs-button v-if="!disabled" :disabled="upload" type="border" size="small" @click="select">
      Seleziona file
    </vs-button>
    <vs-button v-if="value" type="border" size="small" color="success" @click="getFile">
      Scarica
    </vs-button>
    <vs-button v-else-if="disabled" :disabled="true" type="border" size="small" color="danger">
      Nessun file
    </vs-button>
    <div class="label">
      <span class="span-label">{{label}}</span>
      <!-- <pre>{{upload}}</pre> -->
      <vs-progress v-if="upload" :percent="upload.percent" color="primary"></vs-progress>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {

    },
    value: {

    },
    disabled: {

    },
  },
  data () {
    return {
      state: 'Vuoto',
      upload: null,
    }
  },

  methods: {
    getFile() {
      axios.post(process.env.VUE_APP_BACKEND_API+'/modulo-tirocinio/download', { nome: this.label.slice(0,15), nuovo_nome: this.value },{
          headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
          withCredentials: true,
          responseType: 'blob'
        })
        .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data], {type:'application/octet-stream'}));
        const link = document.createElement('a');
        link.href = url
        this.$vs.loading.close()
        link.setAttribute('download', response.headers['x-file-name']);
        document.body.appendChild(link);
        link.click();
      })
        .catch(e => console.log(e))
    },

    select() {
      this.pickFile(file => {
        this.upload = {
          percent: 1,
        }
        let fd = new FormData()
        fd.append('file', file)
        $http.post('modulo-tirocinio/upload', fd, {
          onUploadProgress: ev => {
            this.upload.percent = 1+Math.round((ev.loaded * 100) / ev.total)
          },
        }).then(res => {
          this.$emit('input', res.data, this.label)
        }).finally(res => {
          this.upload = null
        })
      })
    },

    pickFile (on_ok, on_cancel) {
      var input = document.createElement('input')
      input.setAttribute('type', 'file')
      input.click()
      input.onchange = e => {
        var f = e.target.files[0]
        if (!f) {
          on_cancel && on_cancel()
        } else {
          on_ok && on_ok(f)
        }
      }
    },


    formData(data, name, fd) {
      fd = fd || new FormData()
      name = name || ''
      if (data && typeof data === 'object' && data.constructor.name != 'File') {
        if (Object.values(data).length == 0) {
          this.formData('', name, fd)
        } else {
          for (var index in data) {
            var value = data[index]
            if (name == '') {
              this.formData(value, index, fd)
            } else {
              this.formData(value, name + '[' + index + ']', fd)
            }
          }
        }
      } else if (data !== undefined && typeof data != 'function') {
        fd.append(name, data)
      }
      return fd
    },
  },
}
</script>

<style lang="scss">
.file-pick {
  display: flex;
  flex-direction: row;
  button {
      margin-right: 10px;
      white-space: nowrap;
  }
  .label {
    flex-grow: 1;
    .span-label {
      font-size: .9rem;
    }
  }
}
</style>
